import { AiMessage } from "@/src/data/allTypes";
import { getItemId, getUserId, uid } from "@/src/utils/utils";
import apiFetchStream, { useStreamQuery } from "../utils/apiFetchStream";
import { useRouterHook } from "../utils/routerHook";
import AiMessageCard from "../app/aiTasks/aiMessageCard";

function AiAnswerCard({
  lastMessage,
  discussionId,
  discussionRef,
  onFinish,
}: {
  lastMessage: AiMessage | null | undefined;
  discussionId: string;
  discussionRef: React.RefObject<HTMLDivElement>;
  onFinish: (fullValue: { type: any; content: string }) => void;
}) {
  const { getParamFromUrl } = useRouterHook();
  const {
    data,
    isLoading,
    isError,
    error,
    currentJson,
    currentValue,
    fullValue,
  } = useStreamQuery({
    queryKey: ["AiAnswerCard", getItemId(lastMessage)],
    parseChunk: (chunk) => chunk,
    onStreamChunk: (chunk) => {
      console.log("chunk", chunk);
      discussionRef.current?.scrollTo({
        top: discussionRef.current?.scrollHeight + 30,
        behavior: "smooth",
      });
    },
    onStreamComplete: (fullValue) => {
      setTimeout(() => {
        onFinish(JSON.parse(fullValue));
      }, 100);
    },
    queryFn: async () => {
      if (!lastMessage) return null;
      if (lastMessage.role == "assistant") return null;
      return apiFetchStream(
        "aiMessages",
        "generateAiAnswer",
        {
          discussionId,
          patientId: getParamFromUrl("patientId", "patients"),
          consultationId: getParamFromUrl("consultationId", "consultations"),
          hospitalisationId: getParamFromUrl("hospitalisationId", "hospitalisations"),
        },
        "Erreur lors du chargement des questions"
      );
    },
  });

  if (!currentJson?.content) return null;

  return (
    <AiMessageCard
      key={uid()}
      message={{
        content: currentJson?.content || "",
        creator: getUserId(),
        role: "assistant",
        actionType: "information",
        discussionId,
        tasks: [],
      }}
    />
  );
}

export default AiAnswerCard;
